import Vue from 'vue'
import withRender from './icon.html'
import './icon.scss'

export default withRender(Vue.extend({

  data() {
    return {
      icon: {},
      labelId: ''
    }
  },
  props: {
    ariaHidden: {
      type: Boolean,
      default: true
    },
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'sm'
    },
    title: { type: String }
  },
  computed: {
    classes() {
      return [`tt-o-icon--${this.name}`, `tt-o-icon--${this.size}`]
    },
    iconId() {
      return `#tt-icon-${this.name}`
    }
  },
  watch: {
    ariaHidden() {
      if (this.title && !this.labelId) {
        this.labelId = `tt-icon-${Math.random().toString(16).slice(5)}`
      }
    }
  },
  created() {
    if (this.title) {
      this.labelId = `tt-icon-${Math.random().toString(16).slice(5)}`
    }
    if (!this.ariaHidden && !this.title && process.env.NODE_ENV === 'development') {
      // tslint:disable:next-line no-console
      console.error(`Icon ${this.name} needs a title or ariaHidden to be true`)
    }
  }
}))
